import {useState, useRef, useEffect} from 'react';
import showdown from 'showdown';
import apiClient from '../services/apiClient';
import {Tooltip, OverlayTrigger} from 'react-bootstrap';
import {FileEarmarkArrowDown, Copy, CursorText} from 'react-bootstrap-icons';

function Results(content, location) {
  const conv = new showdown.Converter(); //init md converter
  const contentRef = useRef(null);
  const [downloadError, setDownloadError] = useState('');

  const selectAllResult = async () => {
    if (contentRef.current) {
      var range = document.createRange();
      range.selectNode(contentRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
    }
  };

  const downloadTooltip = (props) => (
    <Tooltip id='button-tooltip' {...props}>
      {downloadError ? downloadError : 'Download results as a DOC file'}
    </Tooltip>
  );

  const copyTooltip = (props) => (
    <Tooltip id='button-tooltip' {...props}>
      Select All results
    </Tooltip>
  );
  const downloadResult = () => {
    setDownloadError('');
    apiClient
      .post(
        'https://fa-persona-backend-test2.azurewebsites.net/api/generation/convert_document',
        JSON.stringify({
          htmlBody: conv.makeHtml(content.content),
          processName: 'test',
        }),
        {
          responseType: 'blob',
        }
      )
      .then((res) => {
        console.log(res);

        const href = URL.createObjectURL(new Blob([res.data]));
        var arrayBuffer = res.data;
        var blob = new Blob([arrayBuffer], {
          type: 'application/msword',
        });
        var url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;

        link.setAttribute('download', 'file.docx'); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      })
      .catch((error) => {
        console.error('Error downloading document:', error);
        setDownloadError('Failed to download document. Try again later.');
      });
  };

  return (
    <>
      <h6 className='results-header'>
        This has been created using Open AI - Please ensure to check for
        accuracy before using it.
      </h6>
      <div className='d-grid gap-3 d-md-flex justify-content-md-end result-button-bar'>
        <OverlayTrigger
          placement='bottom'
          delay={{show: 350, hide: 400}}
          overlay={copyTooltip}>
          <CursorText onClick={selectAllResult} />
        </OverlayTrigger>
        <OverlayTrigger
          placement='bottom'
          delay={{show: 350, hide: 400}}
          overlay={downloadTooltip}>
          <FileEarmarkArrowDown onClick={downloadResult} />
        </OverlayTrigger>
      </div>

      <div className='result-container shadow-sm'>
        <div className='result' ref={contentRef}>
          <div
            dangerouslySetInnerHTML={{
              __html: conv.makeHtml(content.content),
            }}></div>
        </div>
      </div>
    </>
  );
}

export default Results;
